const Icon = () => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.985.149c-.502.004-1.003.365-1.003 1.074v7.42c0 1.078-1.39.99-1.39 0v-7.42c0-1.418-2.01-1.418-2.01 0v7.48c0 1.71 1.225 2.848 2.686 2.848 1.501 0 2.722-1.137 2.722-2.848v-7.48C8.99.5 8.486.146 7.985.149zm5.063-.005c-.407 0-.716.282-.87.621L9.945 4.6c-.155.355-.268.754-.268 1.017 0 .236.031.444.114.636l2.416 6.02H2.826c-.338 0-.617-.353-.617-.68V1.223C2.14-.195.186-.176.143 1.286l.042 10.987c0 1.197.887 2.155 2.024 2.155H15l-3.117-8.32c-.086-.31-.124-.591.085-.96l2.063-3.5c.029-.072.071-.38.071-.47C14.06.543 13.583.116 13.048.144z"
            fill="#fff"
        />
    </svg>
);

export default Icon;
